







































import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { AssetsModule } from '@/store/modules/asset'
import { ErrorsModule } from '@/store/modules/error'
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { ImageClipper } from '@/utils/imageClipper'
import { ToolbarDeactivations, ToolbarUploads, ToolbarModule } from '@/store/modules/toolbar'
import EventBus from '@/utils/eventBus'

@Component({
    name: 'image-editor'
})
export default class ImageEditor extends Vue {

    @Prop() private backgroundImg!: string
    @Prop() private step!: number
    @Prop() private usageName!: string
    @Prop() private placeholderStyle!: string[]

    private dragging = false
    private dragX = 0
    private dragY = 0
    private imageClipper = ImageClipper.getImageClipper(true, this.step, this.usageName)
    private image = { url: '', style: ''}
    private oldImage = { url: '', style: ''}
    private blending = false
    private hasUploadListener = false

    get hasClippingSlot() {
        return !!this.$slots['clipping']
    }

    get hasOverlaySlot() {
        return !!this.$slots['overlay']
    }

    get zoom() {
        return ToolbarModule.zoom
    }

    set zoom(zoom: number) {
        ToolbarModule.SetZoom(zoom)
    }

    get rotation() {
        return ToolbarModule.rotation
    }

    set rotation(rotation: number) {
        ToolbarModule.SetRotation(rotation)
    }

    get center() {
        return ToolbarModule.center
    }

    set center(center: [number,number]) {
        ToolbarModule.SetCenter(center)
    }

    get selectedAssets() {
        return AssetsModule.selectedAssets
    }

    get disabledMovement() {
        return ToolbarModule.deactivated & ToolbarDeactivations.ZoomAndRotation
    }

    get error() {
        return ToolbarModule.error
    }

    initiateUpload($event: MouseEvent | TouchEvent) {
        window.console.log('image upload clicked')
        EventBus.$emit('IMAGE_UPLOAD', $event)
    }

    @Watch('selectedAssets')
    selectedAssetsChanged(newSelectedAssets: AssetFile[]) {
        let asset: AssetFile | undefined = AssetsModule.selected;
        if (this.image.url !== '') {
            this.oldImage = { url: this.image.url, style: this.image.style }
        } else {
            //@ts-ignore
            this.oldImage = { url: this.backgroundImg, style: 'width:100%' }
        }
        setTimeout(() => {
            let usageName = this.imageClipper.usageName
            ToolbarModule.SetToolbarError(false)
            if (usageName) {
                ErrorsModule.SetError({ key: usageName })
            }
            if (usageName && asset !== undefined && asset.pendingUsage[usageName]) {
                let usage = asset.pendingUsage[usageName] as SingleAssetUsage
                this.imageClipper.initializeUsage(usage, asset.rect)
                this.image = { url: asset.url, style: this.imageClipper.transformation }
                ToolbarModule.Initialize({ rotation: usage.rotation, zoom: usage.zoom, center: [...usage.center] as [number, number] })
            } else {
                this.imageClipper.reset()
                this.image = { url: '', style: '' }
                ToolbarModule.Initialize({ rotation: 0, zoom: 0, center: [0,0] })
            }
            setTimeout(() => {
                this.blending = true
                setTimeout(() => {
                    this.oldImage = { url: '', style: '' }
                    this.blending = false
        }, 500) }, 100) }, 100)
    }

    @Watch('zoom')
    zoomChanged(newZoom: number) {
        if (this.imageClipper.zoom !== newZoom) {
            this.imageClipper.zoom = newZoom
            this.image = { ...this.image, style: this.imageClipper.transformation }
        }
    }

    @Watch('rotation')
    rotationChanged(newRotation: number) {
        if (this.imageClipper.rotation !== newRotation) {
            this.imageClipper.rotation = newRotation
            this.image = { ...this.image, style: this.imageClipper.transformation }
        }
    }

    startDrag(evt: MouseEvent | TouchEvent) {
        if (this.disabledMovement) {
            return
        }
        if (evt instanceof MouseEvent) {
            if (evt.buttons === 1) {
                this.dragging = true;
                this.dragX = evt.pageX
                this.dragY = evt.pageY
            }
        } else {
            if (evt.touches.length === 1) {
                this.dragging = true
                this.dragX = evt.touches[0].pageX
                this.dragY = evt.touches[0].pageY
                evt.preventDefault()
            }
        }
    }

    doDrag(evt: MouseEvent | TouchEvent) {
        if (this.disabledMovement) {
            return
        }
        if (this.dragging) {
            if (evt instanceof MouseEvent) {
                this.imageClipper.move([evt.pageX - this.dragX, evt.pageY - this.dragY])
                this.dragX = evt.pageX
                this.dragY = evt.pageY
                this.image = { ...this.image, style: this.imageClipper.transformation }
            } else {
                if (evt.touches.length === 1 && this.dragging) {
                    this.imageClipper.move([evt.touches[0].pageX - this.dragX, evt.touches[0].pageY - this.dragY])
                    this.dragX = evt.touches[0].pageX
                    this.dragY = evt.touches[0].pageY
                    this.image = { ...this.image, style: this.imageClipper.transformation }
                    evt.preventDefault()
                }
            }
        }
    }

    stopDrag() {
        if (this.disabledMovement) {
            return
        }
        this.dragging = false;
    }

    mounted() {
        window.addEventListener('mouseup', this.stopDrag)
        window.addEventListener("touchend", this.stopDrag)
        window.addEventListener('mousemove', this.doDrag)
        this.selectedAssetsChanged(AssetsModule.selectedAssets)
        EventBus.isRegistered('IMAGE_UPLOAD', (isRegistered: boolean) => {
            window.console.log('changed isRegistered to ' + isRegistered)
            this.hasUploadListener = isRegistered
        })
    }

    beforeDestroy() {
        window.removeEventListener('mouseup', this.stopDrag)
        window.removeEventListener('touchend', this.stopDrag)
        window.removeEventListener('mousemove', this.doDrag)
        EventBus.stopRegistered('IMAGE_UPLOAD')
    }
}
